export default __webpack_public_path__ + "static/media/psc-cta.f6b7f133.png";